<template>
  <Select :source="`vendor-account/search`" placeholder="Vendor Account" :value="action.value" @changeValue="store.commit(`${storeId}.value`, $event)"></Select>
</template>

<script>
import DefaultValue from './DefaultValue.vue'
export default {
  extends: DefaultValue
}
</script>
